// extracted by css-extract-rspack-plugin
export default {"wrapper":"VacationMaskOverlay_wrapper__VT65l"};